import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-tai-chi-move',
	options: {
		// TODO(DEV-33000): согласовать с CRM до запуска. userTags скопирован с предшественника
		// (activity-female-tai-chi-walking-v2); userFlags пуст намеренно — hasAccessToWalkingVideos
		// открывает видео в приложении Simple, Move-пользователю не нужен. Braze app_scope
		// simple_moves живёт на бэке (DEV-33167).
		userFlags: [],
		userTags: ['tai_chi_walking'],
	},
	landing: {
		ids: ['loader-tai-chi-move-f', 'age-tai-chi-move-f'],
		route: {
			path: '/tai-chi-move-f',
			name: 'tai-chi-move-f-funnel',
		},
	},
	funnel: {
		id: 'ob-female-tai-chi-move',
		route: {
			path: '/tai-chi-move-f/ob/:page(.*)?',
			name: 'activity-female-tai-chi-move',
		},
		slug: 'activity-female-tai-chi-move',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-tai-chi-move-f',
	},
	upsell: {
		routeNames: ['upsell-tai-chi-move-f'],
	},
}

export default appAreaConfig
